export default __webpack_public_path__ + "static/media/artwork1.d1ec2c7a.jpg";